import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Heart } from "lucide-react";
import { getSection } from "@/data/siteContent";
import { COLORS } from "@/lib/api";
import ComingSoon from "@/components/ComingSoon";

const SubPage = ({ sectionKey }) => {
  const { slug } = useParams();
  const section = getSection(sectionKey);
  const sub = section?.subpages.find((s) => s.slug === slug);
  if (!section || !sub) return null;
  if (!sub.ready) return <ComingSoon section={section} sub={sub} />;
  const accent = COLORS[section.color];

  return (
    <div data-testid={`subpage-${sub.slug}`} className="max-w-4xl mx-auto px-6 md:px-12 py-16">
      <Link
        to={section.path}
        data-testid="subpage-back"
        className="inline-flex items-center gap-2 text-sm font-semibold text-brand-ink/60 hover:text-brand-ink mb-8"
      >
        <ArrowLeft size={16} /> {section.title}
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <span className="inline-block w-16 h-1.5 rounded-sm mb-6" style={{ background: accent }} />
        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-brand-ink">
          {sub.title}
        </h1>
        <p className="mt-5 text-lg md:text-xl text-brand-ink/70 leading-relaxed">{sub.intro}</p>

        {sub.body?.map((p, i) => (
          <p key={i} className="mt-5 text-brand-ink/80 leading-relaxed">
            {p}
          </p>
        ))}

        {sub.bullets?.length > 0 && (
          <ul className="mt-8 space-y-3">
            {sub.bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-3">
                <span
                  className="mt-1.5 w-2.5 h-2.5 rounded-full flex-shrink-0"
                  style={{ background: accent }}
                />
                <span className="text-brand-ink/80">{b}</span>
              </li>
            ))}
          </ul>
        )}

        {sub.isDonate && (
          <a
            href="#"
            data-testid="donate-now-btn"
            className="mt-10 inline-flex items-center gap-2 bg-brand-magenta text-white font-semibold px-7 py-3.5 rounded-sm hover:bg-brand-orange transition-colors duration-200"
          >
            <Heart size={18} /> Dona ahora
          </a>
        )}
      </motion.div>
    </div>
  );
};

export default SubPage;
